/* src/app/main/pages/about/about.component.css */
/*# sourceMappingURL=about.component.css.map */
